import locales from './../../content.json';

function getLang() {
    let lang = window.navigator.language.slice(0, 2);

    for (const [key] of Object.entries(locales)) {
        if (key === lang) {
            document.querySelector('html').setAttribute('lang', lang);
            return lang;
        }
    }

    return 'en';
}

function localisation() {
    let localisationNodes = document.querySelectorAll('[data-i18n]');

    let lang = getLang();

    localisationNodes.forEach((node) => {
        let langID = node.dataset.i18n;
        let content = locales[lang][langID];

        node.innerHTML = content;
    });
}

export default localisation;